module.exports = __webpack_public_path__ + "Mindfulness-978b8023847264d190394bbf2667ce8c.png";